import { action } from 'utils/actions'

export const EVENT_GROUP_LOAD_PAGE = 'EVENT_GROUP_LOAD_PAGE'
export const EVENT_GROUP_LOAD_PERFORMANCES = 'EVENT_GROUP_LOAD_PERFORMANCES'
export const EVENT_GROUP_LOAD_PAST_PERFORMANCES = 'EVENT_GROUP_LOAD_PAST_PERFORMANCES'
export const EVENT_GROUP_SET_PERFORMANCES_VIEW_TYPE = 'EVENT_GROUP_SET_PERFORMANCES_VIEW_TYPE'

export const eventGroupLoadPage = eventGroupId =>
  action(EVENT_GROUP_LOAD_PAGE, { eventGroupId })

export const eventGroupLoadPerformances = (eventGroupId, nextPage = false) =>
  action(EVENT_GROUP_LOAD_PERFORMANCES, { eventGroupId, nextPage })

export const eventGroupLoadPastPerformances = (eventGroupId, nextPage = false) =>
  action(EVENT_GROUP_LOAD_PAST_PERFORMANCES, { eventGroupId, nextPage })

export const eventGroupSetPerformancesViewType = viewType =>
  action(EVENT_GROUP_SET_PERFORMANCES_VIEW_TYPE, { viewType })



/** WEBPACK FOOTER **
 ** ./src/actions/event-group/event-group-actions.js
 **/